
/* injects from baggage-loader */
require('./style.styl');

import AggrChart from './AggrChart'
import {connect} from 'react-redux'

const mapStateToProps = state => {
  const nodes = state.aggr.channelNodes || []
  const links = state.aggr.channelLinks || []

  return {
    nodes,
    links
  }
}

export default connect(mapStateToProps)(AggrChart)



// WEBPACK FOOTER //
// ./client/views/AggreatedAttributionView/AggrChart/index.js